import { useTheme } from '@emotion/react';
import {
  ModalContent,
  ModalContentWrapper,
  ModalTitle,
  ModalTitleWrapper,
} from '../../common/Modal';
import { H2 } from '../../styled/typography';
import { useModal } from '../../../providers/modal';
import SubscribeForm from './index';
import { City } from '../../../models';

function SubscribeModalForm({
  eventId,
  notSeason,
  currentCity,
  onSuccessSubscribe,
}: {
  eventId: number;
  notSeason: boolean;
  onSuccessSubscribe: (email: string) => void;
  currentCity: City;
}) {
  const theme = useTheme();
  const modalState = useModal();
  if (!modalState) {
    return null;
  }
  return (
    <ModalContentWrapper>
      <ModalTitleWrapper setModalState={modalState?.setModalState}>
        <ModalTitle>
          <H2
            css={{
              fontSize: 21,
              color: theme.colors.black,
              lineHeight: '29.4px',
            }}
          >
            Подписка на уведомление
          </H2>
        </ModalTitle>
      </ModalTitleWrapper>
      <ModalContent>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: 7,
          }}
        >
          {notSeason ? (
            <p>
              Сейчас не сезон, но мы сообщим, когда начнутся продажи билетов!
              Оставьте свой e-mail, чтобы быть в курсе первыми!
            </p>
          ) : (
            <p>
              Оставьте e-mail, чтобы мы сообщили, когда билеты снова появятся в
              продаже
            </p>
          )}
          <SubscribeForm
            source={notSeason ? 'SeasonStart' : 'ArchiveSubscription'}
            defaultStyle
            eventId={eventId}
            currentCity={currentCity}
            onSuccessSubscribe={onSuccessSubscribe}
          />
        </div>
      </ModalContent>
    </ModalContentWrapper>
  );
}

export default SubscribeModalForm;
